module.exports = __webpack_public_path__ + "img/ewh-2.cd09ab3f.png";